import React from "react";
import { LoadingOutlined, LogoutOutlined } from "@ant-design/icons";
import {
  Button,
  Space,
  Divider,
  Flex,
  Popconfirm,
  Spin,
  notification,
  Grid,
  message,
} from "antd";
import { useNavigate } from "react-router-dom";
import userServices from "../../APIs/userServices";

const { useBreakpoint } = Grid;

const PageTitle = (data) => {
  const screens = useBreakpoint();
  const isMobile = !screens.md;
  const Heading = data.headingLevel === 1 ? "h1" : "h2";

  const navigate = useNavigate();
  const [isLoading, setIsLoading] = React.useState(false);

  const [messageApi, contextHolder] = message.useMessage();

  const handleLogout = async () => {
    try {
      setIsLoading(true);

      // notification.info({
      //   message: "Logging out",
      //   description: "Please wait while we log you out.",
      //   duration: 0,
      //   key: "logout",
      // });

      messageApi.open({
        type: "loading",
        content: "Logging out...",
        duration: 0,
        key: "logout",
      });

      const response = await userServices.logout();

      if (response?.status === 200) {
        // notification.success({
        //   message: "Logout Successful",
        //   description: "You have been logged out successfully.",
        //   duration: 2,
        //   key: "logout",
        // });

        messageApi.open({
          type: "success",
          content: "Logout Successful",
          duration: 2,
          key: "logout",
        });

        localStorage.removeItem("uniqueKey");
        // localStorage.clear();

        navigate("/login");
      } else {
        // notification.error({
        //   message: "Logout Failed",
        //   description: "There was an error logging you out. Please try again.",
        //   duration: 2,
        //   key: "logout",
        // });

        messageApi.open({
          type: "error",
          content: "There was an error logging you out. Please try again.",
          duration: 2,
          key: "logout",
        });

        console.log("Logout error:", response);

        setIsLoading(false);
      }
    } catch (error) {
      console.error("Logout error:", error);

      // notification.error({
      //   message: "Logout Failed",
      //   description: "There was an error logging you out. Please try again.",
      //   duration: 2,
      //   key: "logout",
      // });

      messageApi.open({
        type: "error",
        content: "There was an error logging you out. Please try again.",
        duration: 2,
        key: "logout",
      });

      setIsLoading(false);
    }
  };

  return (
    <Space
      direction="vertical"
      style={{
        width: "100%",
        marginLeft: "auto",
        marginRight: "auto",
        marginBottom: isMobile ? 30 : 70,
        marginTop: isMobile ? 15 : 20,
      }}
    >
      {contextHolder}

      <Flex
        justify="space-between"
        align="center"
        style={{ position: "relative" }}
      >
        <div>
          <Heading
            style={{
              color: "#002753",
              marginBottom: 0,
              fontSize: data.headingLevel === 1 ? "1.5em" : undefined,
            }}
          >
            {data.title}
          </Heading>

          <p
            style={{
              color: "#4B5563",
              fontSize: "16px",
            }}
          >
            {data.subTitle}
          </p>
        </div>

        <Popconfirm
          title="Logout Confirmation"
          description="Are you sure you want to log out?"
          onConfirm={handleLogout}
          okText="Yes"
          okButtonProps={{
            style: {
              backgroundColor: "#002753",
              color: "white",
              padding: "8px 16px",
              borderRadius: "4px",
            },
          }}
          cancelText="No"
          cancelButtonProps={{
            style: {
              backgroundColor: "white",
              color: "#002753",
              padding: "8px 16px",
              borderRadius: "4px",
            },
          }}
          placement="bottom"
        >
          <Button
            type="primary"
            style={{
              width: "fit-content",
              marginLeft: "auto",
              marginRight: "0",
              backgroundColor: "#002753",
              display: data.buttonText ? "block" : "none",
            }}
            icon={<LogoutOutlined style={{ marginRight: 8 }} />}
          >
            {data.buttonText}
          </Button>
        </Popconfirm>
      </Flex>

      <Divider
        style={{
          borderColor: "lightgray",
          position: "absolute",
          width: "100%",
          left: 0,
          right: 0,
        }}
      />

      {isLoading && (
        <Spin
          spinning={isLoading}
          indicator={<LoadingOutlined spin />}
          fullscreen
        />
      )}
    </Space>
  );
};

export default PageTitle;
